import { css } from 'linaria';
import { aboveTooltip } from 'styles/z-indexs';

export const searchBar = css`
  position: relative;
  height: 48px;
  display: flex;
  width: -webkit-fill-available;
  width: -moz-available;
`;

export const searchbarForm = css``;

export const searchbarInputWrap = css`
  position: fixed;
  /* to disable scroll on focus in safari */
  top: 145px;
  left: -9999px;
  z-index: -1;
  display: flex;
  align-items: center;
  will-change: left, top, width, transform;

  @media (--from-desktop) {
    top: 20px;
  }
`;

export const suggestionsContainer = css`
  position: fixed;
  z-index: ${aboveTooltip + 1};
  display: grid;
  grid-auto-flow: row;
  grid-auto-rows: max-content;
  overflow-x: hidden;
  overflow-y: auto;
  opacity: 0;
  overscroll-behavior: contain;
  -webkit-overflow-scrolling: touch;

  background: var(--background-primary);
  border-radius: var(--rounding-m);
  box-shadow: var(--box-shadow-m);
  padding-top: var(--space-100);
  padding-bottom: var(--space-100);

  @media (--only-mobile) {
    bottom: 0;
    padding-top: var(--space-1000);
    border-radius: unset;
  }
`;

export const suggestionsTitle = css`
  padding: var(--space-150) var(--space-200) var(--space-50) var(--space-200) !important;

  font-size: 14px;
  line-height: 18px;
  color: var(--text-minor);

  @media (--only-mobile) {
    flex: auto;
  }
`;

export const suggestionsWrapper = css`
  display: flex;
  flex-direction: column;
`;

export const suggestionsList = css`
  width: 100%;
`;

export const inputButtonsPlacement = css`
  position: absolute;
  right: var(--space-50) !important;
  display: flex;
  column-gap: var(--space-100);
  align-items: stretch;
`;

export const suggestionsRoot = css`
  display: none;
  background: var(--background-primary);
`;
export const active = css`
  display: block;
`;

export const dividerTop = css`
  position: relative;
  margin-top: var(--space-50);
  padding-top: var(--space-50);

  &::before {
    content: '';
    position: absolute;
    display: block;
    width: calc(100% + var(--space-400));
    border-top: 1px solid var(--control-minor);
    left: var(--space-900);
    top: 0;
  }
`;

export const errorContainer = css`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-top: var(--space-900);
  color: var(--text-secondary);
`;

export const errorTitle = css`
  margin-bottom: var(--space-200);
  text-align: center;
`;
